import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { Content } from '@widgets/RetentionModal/components/Modal/styled';
import { useContext } from 'react';
import { RetentionModalCTX } from '@widgets/RetentionModal/types/config';
function SuccessMessage({ title, copy, onClose }) {
    const { successButtonText } = useContext(RetentionModalCTX);
    return (_jsxs(Content, { className: "wysiwyg", children: [_jsx("span", { className: "h3", children: title }), _jsx("p", { children: copy }), _jsx("button", { className: "btn btn--secondary btn--full", type: "button", onClick: onClose, children: successButtonText })] }));
}
export default SuccessMessage;
